import { render } from "./Error404.vue?vue&type=template&id=34432802"
import script from "./Error404.vue?vue&type=script&lang=js"
export * from "./Error404.vue?vue&type=script&lang=js"

import "./Error404.vue?vue&type=style&index=0&id=34432802&lang=scss"
script.render = render

export default script